import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2293cf50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-info-circle me-2" }),
    /*#__PURE__*/_createTextVNode("โครงสร้างและแผนผังองค์กร")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "จัดการข้อมูลโครงสร้างและแผนผังองค์กรที่แสดงบนหน้าเว็บไซต์")
], -1))
const _hoisted_3 = { class: "card-body my-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-edit me-2" }, null, -1))
const _hoisted_5 = { class: "card card-sub" }
const _hoisted_6 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InformationFormComponent = _resolveComponent("InformationFormComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn btn-primary mb-3",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editClick && _ctx.editClick(...args)))
        }, [
          _hoisted_4,
          _createTextVNode("แก้ไข ")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
            [_directive_dompurify_html, _ctx.information?.organization.replace(/(?:\r\n|\r|\n)/g, '<br />')]
          ])
        ])
      ])
    ]),
    _createVNode(_component_InformationFormComponent, {
      ref: "informationForm",
      mode: "ORGANIZATION"
    }, null, 512)
  ], 64))
}